import React, { useState, useEffect } from 'react';
import { auth } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import ClassList from './ClassSection/ClassList';
import ClassDetails from './ClassSection/ClassDetails';
import Preloader from '../Preloader';

const ClassSection = () => {
  const [selectedClass, setSelectedClass] = useState(null);
  const [loading, setLoading] = useState(true);
  const user = auth.currentUser;

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setLoading(false);
      } else {
        window.location.href = '/sign-in';
      }
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (
    <>
       <section
      id="classes-workspace"
      className="flex w-full min-w-0 flex-col items-stretch justify-start p-0"
      style={{ backgroundColor: "var(--section-bg)", color: "var(--text-color)" }}
    >
      {selectedClass ? (
        <ClassDetails
          selectedClass={selectedClass}
          closeClass={() => setSelectedClass(null)}
        />
      ) : (
        <ClassList selectClass={setSelectedClass} user={user} />
      )}
      </section>
    </>
  );
};

export default ClassSection;
